<template>
  <form method="post" @submit.prevent="submitForm">

    <div class="row" v-if="removedItems.length > 0">
      <div class="col-md-12">
        <h5>Removed Items</h5>
        <ul class="list-group">
          <li
            v-for="(item, index) in removedItems"
            :key="index"
            class="
              list-group-item
              d-flex
              justify-content-between
              align-items-center
            "
          >
            <span>
              {{ item.ItemName }}
            </span>
            <button
                type="button"
              v-on:click="
                waybillItems.push(item);
                removedItems.splice(index, 1);
                return false;
              "
               class="btn btn-primary btn-sm"
              >Add item</button
            >
          </li>
        </ul>
      </div>
    </div>
    <hr />
    <div class="row">
      <div
        v-for="(item, index) in waybillItems"
        :key="index"
        class="col-md-12 mb-5"
      >
        <div class="text-right">
          <span
            class="btn btn-sm btn-danger"
            data-toggle="tooltip"
            data-placement="top"
            title="Remove item"
            @click="removeRow(index, item)"
          >
            Remove Item
            <!-- <i class="fas fa-trash-alt"></i> -->
          </span>
        </div>
        <input
          type="text"
          name="ItemName"
          class="form-control is-valid bg-gray-light"
          v-model="item.ItemName"
          readonly
        />
        <span class="badge badge-info text-white">
          Demanded Quantity - {{ item.DemandedQuantity }}
        </span>
        <span class="badge badge-success">
          Approved Quantity - {{ item.ApprovedQuantity }}
        </span>
        <span class="badge badge-primary text-white">
          Issued Quantity - {{ item.IssuedQuantity }}
        </span>
        <span class="badge badge-warning text-white">
          Back Order Quantity - {{ item.BackOrderQuantity }}
        </span>
        <span class="badge badge-danger">
          Warehouse Available Quantity - {{ item.AvailableQuantity }}
        </span>

        <waybill-item-batch
          :item-batches="item.Batches"
          :item-id="item.ItemId"
          ref="waybillItemBatches"
        ></waybill-item-batch>
        <hr />
      </div>
    </div>
    <button type="submit" class="btn btn-primary">Save</button>
  </form>
</template>

<script>
import WaybillItemBatch from "./WaybillItemBatch.vue";

export default {
  name: "waybill-items",
  components: {
    "waybill-item-batch": WaybillItemBatch,
  },
  props: ["inventoryRequestId", "purchaseOrderId", "WarehouseInventoryDebitId"],
  data() {
    return {
      waybillItems: {},
      formData: null,
      removedItems: [],
    };
  },
  methods: {
    submitForm() {
      var allBatches = this.$refs.waybillItemBatches;

      var singleBatch = [];
      this.waybillItems.forEach(function (item, index) {
        singleBatch.push(allBatches[index].data);
      });
      this.formData = {
        InventoryRequestId: this.inventoryRequestId,
        WarehouseInventoryDebitId: this.WarehouseInventoryDebitId,
        data: singleBatch,
      };
      this.postWaybillItems();
    },
    postWaybillItems() {
      axios
        .post("waybill/items/store/" + this.WarehouseInventoryDebitId, this.formData)
        .then((response) => {
          Swal.fire({
            title: "Submitted Successfully",
            icon: "success",
          });
          // location.reload();
        })
        .catch((error) => {
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    },
    getWaybillItems() {
      axios
        .get("waybill/items/" + this.inventoryRequestId)
        .then((response) => {
          this.waybillItems = response.data.data;
        })
        .catch((error) => {
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    },
    removeRow: function (index, item) {
      toastr.options.progressBar = true;
      toastr.options.closeDuration = 2000;
      toastr.info("Item " + item.ItemName + " removed. ");
      this.waybillItems.splice(index, 1);
      this.removedItems.push(item);
    },
  },

  mounted() {
    this.getWaybillItems();
  },
};
</script>

<style lang="scss" scoped>
</style>
